<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#">المراكز النموذجية </a> </li>
        </template>
    </Path>

    <section id="content">
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <div class="nav flex-column nav-pills me-3 border  shadow-sm p-4 rounded-3"
                                    id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                    <button class="nav-link active border-bottom" id="v-pills-center1-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-center1" type="button" role="tab"
                                        aria-controls="v-pills-center1" aria-selected="true"> المراكز النموذجية الحديثة
                                        <i class="bi bi-chevron-left"></i></button>
                                    <button class="nav-link border-bottom" id="v-pills-center2-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-center2" type="button" role="tab"
                                        aria-controls="v-pills-center2" aria-selected="false">المركز النموذجى بقطاع
                                        الأحوال المدنية بالعباسية <i class="bi bi-chevron-left"></i></button>
                                    <button class="nav-link border-bottom" id="v-pills-center3-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-center3" type="button" role="tab"
                                        aria-controls="v-pills-center3" aria-selected="false">المراكز النموذجية بمراكز
                                        التسوق التجارية (المولات)<i class="bi bi-chevron-left"></i></button>
                                    <button class="nav-link border-bottom" id="v-pills-center4-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-center4" type="button" role="tab"
                                        aria-controls="v-pills-center4" aria-selected="false">المراكز النموذجية
                                        التكنولوجية المتنقلة<i class="bi bi-chevron-left"></i></button>
                                    <button class="nav-link border-bottom" id="v-pills-center5-tab"
                                        data-bs-toggle="pill" data-bs-target="#v-pills-center5" type="button" role="tab"
                                        aria-controls="v-pills-center5" aria-selected="false">خدمة الترجمة وإستخراج
                                        وثائق الأحوال المدنية باللغات الأجنبية<i
                                            class="bi bi-chevron-left"></i></button>
                                </div>
                            </div>
                            <div class="col-md-8 col-12">
                                <div class="tab-content" id="v-pills-tabContent">
                                    <div class="tab-pane fade show active" id="v-pills-center1" role="tabpanel"
                                        aria-labelledby="v-pills-center1-tab" tabindex="0">
                                        <h1 class="blueFont py-3"> المراكز النموذجية</h1>

                                        <div class="accordion" id="accordionExample">
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingOne">
                                                    <button class="accordion-button  shadow-sm border rounded-3 my-4"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseOne" aria-expanded="true"
                                                        aria-controls="collapseOne">
                                                        المراكز النموذجية الحديثة
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show"
                                                    aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        إستحدث قطاع الأحوال المدنية عدداً كبيراً من المراكز النموذجية
                                                        على مستوى الجمهورية موزعة بمختلف المحافظات، والتى تقدم خدمات
                                                        مميزة للمواطنين فى سهولة ويسر وبصورة حضارية من خلال أماكن لائقة
                                                        ، دون التقيد بمحل الإقامة ، وتمتد ساعات العمل بالعديد منها حتى
                                                        الساعة 9 مساءاً طوال أيام الإسبوع، وذلك لتقديم الخدمات الخاصة
                                                        بالأحوال المدنية بجودة عالية لأكبر عدد ممكن من المواطنين.
                                                        <br>
                                                        <img src="@/assets/images/IdealCenters/Center01/01.jpg" alt=""
                                                            class="img-fluid py-3">
                                                        <br>
                                                        <img src="@/assets/images/IdealCenters/Center01/02.jpg" alt=""
                                                            class="img-fluid py-3">
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <!--end-tab-->
                                    <div class="tab-pane fade" id="v-pills-center2" role="tabpanel"
                                        aria-labelledby="v-pills-center2-tab" tabindex="0">
                                        <h1 class="blueFont py-3"> المراكز النموذجية</h1>


                                        <div class="accordion" id="accordionExample">
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingOne">
                                                    <button class="accordion-button  shadow-sm border rounded-3 my-4"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseOne" aria-expanded="true"
                                                        aria-controls="collapseOne">
                                                        المركز النموذجى بقطاع الأحوال المدنية بالعباسية
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show"
                                                    aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        تم إفتتاح المركز النموذجى لقطاع الأحوال المدنية لتقديم الخدمات
                                                        الفورية بمقر ديوان القطاع بمنطقة العباسية بالقاهرة، وفق تصميم
                                                        هندسى متميز وبتجهيزات فنية تواكب الثورة التكنولوجية التى تشهدها
                                                        البلاد وتلبى مطالب المواطنين من القطاع بشكل فورى دون عناء و
                                                        إزدحام وبصورة تليق بمكانة المواطن ، كما أنه مزود بكافتيريا
                                                        (Coffee Shop) لتقديم مختلف المشروبات والوجبات الجاهزة للمواطنين
                                                        أثناء إنتظارهم للحصول على الخدمات المطلوب الحصول عليها. <br>
                                                        <img src="@/assets/images/IdealCenters/Center02/01.jpg" alt=""
                                                            class="img-fluid py-3">
                                                        <br>
                                                        <img src="@/assets/images/IdealCenters/Center02/02.jpg" alt=""
                                                            class="img-fluid py-3">
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="v-pills-center3" role="tabpanel"
                                        aria-labelledby="v-pills-center3-tab" tabindex="0">
                                        <h1 class="blueFont py-3"> المراكز النموذجية</h1>


                                        <div class="accordion" id="accordionExample">
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingOne">
                                                    <button class="accordion-button  shadow-sm border rounded-3 my-4"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseOne" aria-expanded="true"
                                                        aria-controls="collapseOne">
                                                        المراكز النموذجية بمراكز التسوق التجارية (المولات)
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show"
                                                    aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        حرص قطاع الأحوال المدنية على إنشاء مراكز نموذجية بمراكز التسوق
                                                        (المولات) بما يخدم شريحة كبيرة من المواطنين المترددين عليها
                                                        للتسوق، لتصبح الخدمة أقرب إليهم دون التقيد بأماكن الإقامة الخاصة
                                                        بهم، وحفاظاً على أوقات المواطنين، وتعمل هذه المراكز طوال أيام
                                                        الاسبوع (ومنها يوم الجمعة) وتمتد ساعات العمل بالعديد منها حتى
                                                        الساعه 9م، ويتم من خلالها تقديم كافة خدمات القطاع من مصدرات
                                                        (ميلاد – وفاة – زواج – طلاق – قيد عائلى – قيد فردى) وكذلك إصدار
                                                        بطاقات الرقم القومى (الخاصة/ المميزة) والتى تسلم فى ذات اليوم أو
                                                        خلال 24 ساعة
                                                        <img src="@/assets/images/IdealCenters/Center03/01.png" alt=""
                                                            class="img-fluid py-3">
                                                        <br>
                                                        <img src="@/assets/images/IdealCenters/Center03/02.png" alt=""
                                                            class="img-fluid py-3">
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="v-pills-center4" role="tabpanel"
                                        aria-labelledby="v-pills-center4-tab" tabindex="0">
                                        <h1 class="blueFont py-3"> المراكز النموذجية</h1>


                                        <div class="accordion" id="accordionExample">
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingOne">
                                                    <button class="accordion-button  shadow-sm border rounded-3 my-4"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseOne" aria-expanded="true"
                                                        aria-controls="collapseOne">
                                                        المراكز النموذجية التكنولوجية المتنقلة
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show"
                                                    aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        يتم إرسال المراكز النموذجية التكنولوجية المتنقلة لخدمة المواطنين
                                                        بالأماكن الأكثر كثافة سكانية والتى تعانى من بُعد المسافات عن
                                                        مواقع السجلات عن طريق إرسال العديد من القوافل المجهزة فنياً
                                                        ولوجستياً بأحدث الأجهزة لتقديم كافة خدمات القطاع من المصدرات
                                                        المميكنة وبطاقات الرقم القومى وخصوصاً بالمناطق الأكثر إحتياجاً ,
                                                        ويتم ذلك فى إطار مبادرة (كلنا واحد) لرفع الاعباء عن كاهل
                                                        المواطنين وتجنباً لمشقة وتكاليف الذهاب لمكاتب السجلات المدنية،
                                                        إنطلاقاً من مسئولية وزارة الداخلية الهادفة لتقديم أوجه الرعاية
                                                        الإنسانية والمجتمعية للمواطنين .
                                                        <img src="@/assets/images/IdealCenters/Center04/01.jpg" alt=""
                                                            class="img-fluid py-3">
                                                        <br>
                                                        <img src="@/assets/images/IdealCenters/Center04/02.jpg" alt=""
                                                            class="img-fluid py-3">
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="v-pills-center5" role="tabpanel"
                                        aria-labelledby="v-pills-center5-tab" tabindex="0">
                                        <h1 class="blueFont py-3"> المراكز النموذجية</h1>


                                        <div class="accordion" id="accordionExample">
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="headingOne">
                                                    <button class="accordion-button  shadow-sm border rounded-3 my-4"
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseOne" aria-expanded="true"
                                                        aria-controls="collapseOne">
                                                        خدمة الترجمة وإستخراج وثائق الأحوال المدنية باللغات الأجنبية
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show"
                                                    aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        يتم إرسال المراكز النموذجية التكنولوجية المتنقلة لخدمة المواطنين
                                                        بالأماكن الأكثر كثافة سكانية والتى تعانى من بُعد المسافات عن
                                                        مواقع السجلات عن طريق إرسال العديد من القوافل المجهزة فنياً
                                                        ولوجستياً بأحدث الأجهزة لتقديم كافة خدمات القطاع من المصدرات
                                                        المميكنة وبطاقات الرقم القومى وخصوصاً بالمناطق الأكثر إحتياجاً ,
                                                        ويتم ذلك فى إطار مبادرة (كلنا واحد) لرفع الاعباء عن كاهل
                                                        المواطنين وتجنباً لمشقة وتكاليف الذهاب لمكاتب السجلات المدنية،
                                                        إنطلاقاً من مسئولية وزارة الداخلية الهادفة لتقديم أوجه الرعاية
                                                        الإنسانية والمجتمعية للمواطنين .
                                                        <img src="@/assets/images/IdealCenters/Center05/01.jpg" alt=""
                                                            class="img-fluid py-3">
                                                        <br>
                                                        <img src="@/assets/images/IdealCenters/Center05/02.jpg" alt=""
                                                            class="img-fluid py-3">
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


</template>

<script>
import Path from '@/components/Path.vue';
export default {
    name: 'IdealCentersComp',
    components: { Path },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
}
</script>